import colorPalette from '../color-palette';

const { background } = colorPalette;

export default {
  MuiFilledInput: {
    root: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      backgroundColor: background.textInput,
      '&:hover': {
        backgroundColor: background.textInput,
        '@media (hover: none)': {
          backgroundColor: background.textInput,
        },
      },
    },
  },
};
